import { Menu } from "antd";
import { SidebarDiv, Stickydiv } from "../../styleComponents";
import BorderDiv from "./BorderDiv";
import GoBack from "./GoBack";
import { useLocation, useNavigate } from "react-router-dom";

export default function Sidebar({ data, url }) {
  const navigate = useNavigate();
  const pathName = useLocation().pathname;
  const lastSegment = pathName.split("/").pop();

  const urlMatch=["create-crm","anydone-crm-ai-agent-platform","managing-crm"]
  return (
    <SidebarDiv>
      <Stickydiv height="25rem">
        <GoBack title={urlMatch.includes(url)?"Automated crm":"AI Agents"} path={urlMatch.includes(url)?"automated-crm":"ai-agents"} />
        <BorderDiv mb={1} mt={1} />
        <div className="started-items sidebar-items">
          <Menu mode="vertical" className="side-menu">
            {data?.map((items, index) => (
              <Menu.Item
                key={index}
                onClick={() => {
                  navigate(`/${url}/${items.link}`);
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }}
                style={lastSegment === items.link ? { color: "#1890ff" } : {}}
              >
                {items.title}
              </Menu.Item>
            ))}
          </Menu>
        </div>
      </Stickydiv>
    </SidebarDiv>
  );
}
